import {Component, OnDestroy, OnInit} from '@angular/core';
import {DossierService} from '../dossier/dossier.service';
import {TokenAssure} from '../dossier/token-assure';
import {Router} from '@angular/router';
import * as OT from '@opentok/client';
import {environment} from '../../environments/environment';
import {DataPosition} from '../dossier/data-position';

@Component({
  selector: 'app-visio',
  templateUrl: './visio.component.html',
  styleUrls: ['./visio.component.css']
})
export class VisioComponent implements OnInit, OnDestroy {
  messageError: string;
  session: OT.Session;

  streams: Array<OT.Stream | any> = [];
  PAGE_DOSSIER = '/dossier';
  TITRE_POPIN = 'Erreur';

  constructor(private dossierService: DossierService, private router: Router) {
  }

  ngOnInit() {
    const refSinistre = localStorage.getItem('refSinistre');
    this.dossierService.getTokenAssure(refSinistre).subscribe((tokenAssure: TokenAssure) => {
      if (!tokenAssure) {
        this.messageError = 'Votre interlocuteur  n\'est pas encore connecté.\n' +
          'Veuillez réessayer ultérieurement.';
      } else {
        this.startStream(tokenAssure);
      }
    }, () => {
      this.messageError = 'Une erreur technique est survenue.';
    });

    navigator.geolocation.getCurrentPosition(position => this.updatePositionVisio(position, refSinistre));

  }

  private updatePositionVisio(position: any, refSinistre: string) {
    const dataPosition = new DataPosition();
    dataPosition.DossierNum = refSinistre;
    dataPosition.Latitude = position.coords.latitude;
    dataPosition.Longitude = position.coords.longitude;
    dataPosition.Precision = position.coords.accuracy;

    this.dossierService.updatePositionVisio(dataPosition).subscribe();
  }

  private startStream(tokenAssure: TokenAssure) {

    if (this.detectIphone()) {
      this.session = OT.initSession(environment.API_KEY_H264, tokenAssure.SessionId);
    } else {
      this.session = OT.initSession(environment.API_KEY_VP8, tokenAssure.SessionId);
    }
    // this.session = OT.initSession(environment.API_KEY_H264, tokenAssure.SessionId);
    this.session.on('streamCreated', (event) => {
      const streamIndex = this.streams.findIndex(stream => stream.name === event.stream.name);
      if (streamIndex === -1) {
        this.streams.push(event.stream);
      } else {
        this.streams[streamIndex] = event.stream;
      }

    });
    this.session.connect(tokenAssure.Token, () => {

    });

  }

  toDossier() {
    this.router.navigate(['/dossier']);
  }

  ngOnDestroy() {
    localStorage.removeItem('canStartVisio');
    if (this.session) {
      this.session.disconnect();
    }
  }

  detectIphone(): boolean {
    return !(navigator.userAgent.search(/(?:iPhone|iPad)/) === -1);
  }

}



// WEBPACK FOOTER //
// ./src/app/visio/visio.component.ts